import Button from 'components/atoms/Button/Button.component';
import { Loader } from 'components/atoms/Loader';
import { Progress } from 'components/atoms/Progress';
import type { FC } from 'react';
import { CheckIcon, TrashIcon, XIcon } from 'utils/icons';
import {
  type FileUploadedItemMap,
  type FileUploadedItemProps,
} from './FileUploaded.types';
import { FileUploadStatus } from 'hooks/filesUploadStoreFactory';

const StatementStatusIconMap: FileUploadedItemMap = {
  waiting: {
    Icon: () => null,
    progressColor: 'blue',
  },
  uploading: {
    Icon: () => (
      <Loader className="!w-4 !h-4 !text-taxes-200 !fill-taxes-700" />
    ),
    progressColor: 'blue',
  },
  error: {
    Icon: () => <XIcon className="text-red-600 w-5 h-5" />,
    progressColor: 'red',
  },
  done: {
    Icon: () => <CheckIcon className="text-green-600 w-5 h-5" />,
    progressColor: 'green',
  },
};

const FileUploadedItemV2: FC<
  FileUploadedItemProps & { showProgress?: boolean }
> = ({ name, size, status, progress, showProgress, onRemove }): JSX.Element => {
  const { progressColor, Icon } = StatementStatusIconMap[status];

  return (
    <div className="border border-primary-50 p-5 py-3 rounded-lg bg-white">
      <div className="flex items-center justify-between">
        <div className="flex w-[70%] items-center space-x-1 flex-1 mr-2">
          <div className="mr-3">
            <Icon />
          </div>

          <h1 className="text-primary text-ellipsis overflow-hidden text-sm font-semibold text-left">
            {name}
          </h1>
        </div>

        <div className="w-[30%] text-right">
          <span className="text-sm text-primary-700 text-right">
            {(size / (1024 * 1024)).toFixed(2)} mb
          </span>
        </div>

        {onRemove && (
          <Button
            onClick={onRemove}
            icon={status === FileUploadStatus.uploading ? XIcon : TrashIcon}
            iconOnly
            structure="text"
            className="text-sm ml-2"
          />
        )}
      </div>

      {showProgress ? (
        <div className="mt-3 mb-1">
          <Progress progress={+progress} color={progressColor} />
        </div>
      ) : null}
    </div>
  );
};

export default FileUploadedItemV2;
